import React, {Component} from 'react';
import PropTypes from 'prop-types';

export class AddTodo extends Component {
    state = {
        title: ''
    };

    onSubmit = (e) => {
        e.preventDefault();
        this.props.addTodo(this.state.title);
        this.setState({title: ''});
    }

    onChange = (e) => this.setState({[e.target.name]: e.target.value});

    render() {
        return (
            <form className="form" onSubmit={this.onSubmit}>
                <input className="form--input" type="text" name="title" placeholder="Add Todo..." value={this.state.title} onChange={this.onChange}/>
                <button className="form--button form--button__submit" type="submit" value="submit">Submit</button>
            </form>
        );
    }
}

//Defining prop types
AddTodo.propTypes = {
    addTodo: PropTypes.func.isRequired
};

export default AddTodo;